import React, { useState,useEffect } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { connect } from "react-redux";
import { getSelectedEmp } from "../../../redux/actions/employee/employee.action";

import { getEmpList } from "../../../redux/actions/employee/employee.action";
import { getSkill } from "../../../redux/actions/adminSettings/adminSettings.action";
import classnames from "classnames";
import {
  TabCertification,
  TabProfile,
  TabProjects,
  TabRewards,
  TabSkill,
  TabAssets
} from "./";

const EmpProfileViewTabs = React.memo((props) => {
  var selectedEmp = props.match.params.empId;
  let empId = selectedEmp;//props.match.params.empId;
  var loginUser = JSON.parse(localStorage.getItem("user"));
  if(loginUser.RoleName != "Admin"){
    empId = loginUser.EmployeeId;
  }
  let RedeemBtnEnableStatus = false;
  if(selectedEmp == loginUser.EmployeeId){
    RedeemBtnEnableStatus = true;
  } 

  const { addEmpSkill,getEmpList,getSkill } = props;
  const { selectEmp, empeducationalInfo } = props.selectEmp;
  const { projectList, employeeProjectList } = props.projectList;
  const { empList } = props.empList;
  const { skillList } = props.skillList;
  const [activeTab, setActiveTab] = useState("profile");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  // Functions.

  const handleAddEmpSkill = React.useCallback(
    (empNewSkill, skillId, whichCategorySkill) => {
      addEmpSkill(empNewSkill, skillId, 29, whichCategorySkill);
    },
    [addEmpSkill]
  );

  useEffect(() => {   
  
    getSkill();
  }, [getSkill]);

  return (
    <div>
      <Nav tabs className="mt-2">
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "profile" })}
            onClick={() => {
              toggle("profile");
            }}
          >
            Profile
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "projects" })}
            onClick={() => {
              toggle("projects");
            }}
          >
            Projects
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "skills" })}
            onClick={() => {
              toggle("skills");
            }}
          >
            Skills
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "certification" })}
            onClick={() => {
              toggle("certification");
            }}
          >
            Certification
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "rewards" })}
            onClick={() => {
              toggle("rewards");
            }}
          >
            Rewards
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "assets" })}
            onClick={() => {
              toggle("assets");
            }}
          >
            Assets
          </NavLink>
        </NavItem>
      </Nav>
      {/* Tab content.----------------------------------------------------- */}
      <TabContent activeTab={activeTab} className="mt-2">
        <TabPane tabId="profile">
          <TabProfile
            {...props}
            selectEmp={selectEmp}
            educationalInfo={empeducationalInfo}
            employeeId={empId}
          ></TabProfile>
        </TabPane>
        <TabPane tabId="projects">
          <TabProjects
            projectList={employeeProjectList}
            employeeId={empId}
            empList={empList}
            skillList={skillList}
          ></TabProjects>
        </TabPane>
        <TabPane tabId="skills">
          <TabSkill employeeId={empId}></TabSkill>
        </TabPane>
        <TabPane tabId="certification">
          <TabCertification employeeId={empId}></TabCertification>
        </TabPane>
        <TabPane tabId="rewards">
          <TabRewards 
          {...props} employeeId={empId}
          RedeemBtnEnableStatus = {RedeemBtnEnableStatus}
          ></TabRewards>
        </TabPane>
        <TabPane tabId="assets">
            <TabAssets
            employeeId={empId}
            ></TabAssets>
        </TabPane>
      </TabContent>
    </div>
  );
});

const mapStateToProps = (state) => ({
  selectEmp: state.empReducer,
  projectList: state.projectReducer,
  empList: state.empReducer,
  skillList: state.adminSettingReducer,
});

export default connect(mapStateToProps, {
  getSelectedEmp, 
  getEmpList,
  getSkill,
})(EmpProfileViewTabs);
